module.exports = __webpack_public_path__ + "img/icon-warning-flom-3.0c9f1801.svg";